/*
 * ---------------------------------------------------------------------
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 WALC Inc. Inc. All Rights Reserved.
 *
 * file=entry-guard.ts
 *
 * This software is the confidential and proprietary information of WALC Inc.
 * (Confidential Information). You shall not disclose such Confidential Information
 * and shall use it only in accordance with the terms of the license agreement
 * you entered into with WALC Inc.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * <summary>: 入口（/entry）で machineGuid を受け取り、BFF のログイン初期化エンドポイントへ
 * ブラウザ全体をリダイレクトするガード。
 * ---------------------------------------------------------------------
 */


import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { EntryMarker } from '../services/entry-marker';

/**
 * 外部アプリからの遷移（?machineGuid=...）を受け付け、
 * BFF のログイン初期化エンドポイントへブラウザ全体をリダイレクトする。
 * BFF は Angular の外にあるサーバーのため、Router.navigate ではなく
 * window.location.href でページ離脱を伴う遷移を行う。
 * 遷移前にこのタブへ入口を通った印を付け、authGuard が直接アクセスと区別できるようにする。
 */
export const entryGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const machineGuid = route.queryParamMap.get('machineGuid');
  if (machineGuid) {
    inject(EntryMarker).mark();
    const entryPoint = route.queryParamMap.get('entryPoint');
    const params = new URLSearchParams({ machineGuid, ...(entryPoint ? { entryPoint } : {}) });
    window.location.href = `/api/auth/login?${params.toString()}`;
    return false;
  }
  return router.createUrlTree(['/error'], {
    queryParams: { reason: 'missing_machine_info' },
  });
};
